import React, { useEffect } from "react"
import "./modal-sizes-intima.scss"
import useMediaQuery from "../../../shared/utils/useMediaQuery"
import GenericModal from "../../../shared/components/modals/generic-modal/generic-modal"

import hipsterSizes from "../../../assets/images/hipsterSizes.png"
import hipsterSizesMB from "../../../assets/images/hipsterSizesMB.jpg"

const ModalSizesIntima = ({close}) => {




  useEffect(() => {
    const body = document.getElementsByTagName("body")[0]
    body.classList.add("body-blook")
    return () => {
      body.classList.remove("body-blook")
    }
  }, [])


  const mobile = useMediaQuery()
  return (
    <div className="f-modal-sizes-intima">
      <div className="f-modal-sizes-intima__content">
        <span className='f-modal-sizes-intima__close' onClick={close} />
        <h2 className="f-modal-sizes-intima__title">Guía de tallas</h2>
        <div className='f-modal-sizes-intima__image'>
          <img src={mobile ? hipsterSizesMB : hipsterSizes}/>
        </div>
      </div>
    </div>

  )
}

export default ModalSizesIntima
